import haversine from 'haversine-distance'

const presentPoint = (p) => p instanceof Point && p.isPresent();

const setPoint = (...args) => {
  let lat = null, lng = null;

  if (args.length == 2) {
    [lat, lng] = args;
  } else if (_.isArray(args[0])) {
    [lat, lng] = args[0]
  } else if (_.isObject(args[0])) {
    ({lat, lng} = args[0]);
    ({latitude:lat=lat, longitude:lng=lng} = args[0]);
    if (lat instanceof Function) {
      lat = lat(), lng = lng();
    }
  }

  return [lat, lng];
}

const mToMi = (meters) => meters * 0.000621371;
const mToFeet = (meters) => meters * 3.28084;

export default class Point {
  constructor() {
    [this.lat, this.lng] = setPoint(...arguments);
  }
  
  get latitude() { return this.getLat(); }
  get longitude() { return this.getLng(); }
  
  array = () => [this.getLat(), this.getLng()]
  isEmpty = () => !this.lat || !this.lng
  isPresent = () => !this.isEmpty()
  eq = (point) => this.lat === point.lat && this.lng === point.lng
  toG = () => ({lat: this.lat, lng: this.lng})
  toString = () => this.array().join(',')
  distanceTo = (point) => haversine(this, point)
  distanceToFeet = (point) => mToFeet(this.distanceTo(point))

  static select(...points) {
    return points.find(presentPoint) || NullPoint
  }

  getLat = () => this.lat
  getLng = () => this.lng
}

export const NullPoint = new Point();

// Usage:
// - new Point(lat, lng)
// - new Point({lat, lng})
// - new Point({latitude, longitude})
// - centerpoint = (new Point({lat, lng}).array())
// - locationDetails = {
//     ...location,
//     ...(new Point(lat, lng))
//   }
// Point.select(point1, point2, point3)
